import {
  CSSObject,
  Drawer,
  FontAwesomeIcon,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MuiDrawer,
  Theme,
  VeBox,
  VeTypography,
  styled,
} from "@packages/ui/mui";
import {
  HELP,
  PROFILE_DOTS,
  SETTINGS,
  SETTINGS_ACTIVE,
  VE_TEXTICON,
} from "@public/index";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import DrawerData from "./drawerData";
import {
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faArrowRightFromBracket,
  faBars,
  faMagnifyingGlass,
} from "@packages/ui/libs";
import { VeSearch } from "@packages/ui/components";
import { useRouter } from "next/navigation";
import { signOut } from "next-auth/react";
import { useData } from "@providers/context";
import { clearLocalStorageExcept } from "@libs/helper";

const drawerWidth = 250;
const DrawerHeader = styled("div")(({ theme }: any) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const openedMixin = (theme: Theme): any => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  // backgroundColor: "#F6F8F9 !important",
  overflow: "visible",
  // height: "calc(0px + 100vh)",
  position: "relative !important",
  display: "flex",
  alignItems: "flex-start",
  // padding: "0px 40px",
  // top: "0px",
  // minHeight: "100vh",
  borderRight: "2px solid #E8E8E8",
});
const openedMixinInvestor = (theme: Theme): any => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  backgroundColor: "#F6F8F9 !important",
  borderRight: "0px",
  // overflowX: "hidden",
  height: "calc(0px + 100vh)",
  position: "relative !important",
  display: "flex",
  alignItems: "flex-start",

  // padding: "0px 40px",
  // top: "0px",
  // minHeight: "100vh",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflow: "visible",
  position: "static",
  borderRight: "2px solid #E8E8E8",
  // minHeight: "100vh",
  // backgroundColor: "#F6F8F9 !important",
  width: `52px`,
  [theme.breakpoints.up("sm")]: {
    width: `52px`,
  },
});
const closedMixinInvestor = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // overflowX: "hidden",
  borderRight: "0px",
  position: "static",
  minHeight: "100vh",
  backgroundColor: "#F6F8F9 !important",
  width: `52px`,
  [theme.breakpoints.up("sm")]: {
    width: `52px`,
  },
});

const StyleDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop: any) => prop !== "open",
})(({ theme, open }: any) => ({
  width: drawerWidth + 0,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  overflow: "visible",
  // borderRight: "2px solid #E8E8E8",
  border: "none !important",
  // backgroundColor: "#F6F8F9",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const StyleDrawerInvestor = styled(MuiDrawer, {
  shouldForwardProp: (prop: any) => prop !== "open",
})(({ theme, open }: any) => ({
  width: drawerWidth + 0,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  borderRight: "0px",
  backgroundColor: "#F6F8F9",
  ...(open && {
    ...openedMixinInvestor(theme),
    "& .MuiDrawer-paper": openedMixinInvestor(theme),
  }),
  ...(!open && {
    ...closedMixinInvestor(theme),
    "& .MuiDrawer-paper": closedMixinInvestor(theme),
  }),
}));

interface MenuItemData {
  text: string;
  path?: string;

  icon?: JSX.Element;
  selectedIcon?: JSX.Element;
  subItems?: MenuItemData[];
}

const WebDrawerUser = ({
  handleDrawerCloseWeb,
  handleDrawerOpen,
  isHovered,
  open,
  selectedItem,
  childSelected,
  handleItemClick,
  setChildSelected,
  pathName,
  setIsHovered,
  anchorElUser,
  handleCloseUserMenu,
}: {
  handleDrawerCloseWeb: any;
  handleDrawerOpen: any;
  isHovered: any;
  handleDrawerClose: any;
  handleDrawerTransitionEnd: any;
  anchorElUser: any;
  handleCloseUserMenu: any;
  selectedItem: string;
  childSelected: string;
  handleItemClick: (text: string, subItems?: MenuItemData[]) => void;
  setChildSelected: (text: string) => void;
  setIsHovered: any;
  pathName?: string;
  open: boolean;
}) => {
  const router = useRouter();
  const { userData } = useData();
  const [search, setSearch] = React.useState<string>("");

  const [openSubItemsAccordionWhenClosed, setopenSubItemsAccordionWhenClosed] =
    React.useState("");
  const handleClearOpenedSubItemsAccordion = () => {
    setopenSubItemsAccordionWhenClosed("");
  };
  //   const isTab = useMediaQuery("(max-width: 900px)");
  interface ProfileItemData {
    label: string;
    path?: string;
    icon?: JSX.Element;
    selectedPath?: string;
    click?: () => void;
  }

  const settings: ProfileItemData[] = [
    {
      label: "Profiles",
      path: "/profile",
      selectedPath: "/fainfo",
      click: () => {
        handleCloseUserMenu();
        router.push("/setting-profile?section=0");
      },
    },
    {
      label: "Sign Out",
      path: "/signOut",
      icon: (
        <FontAwesomeIcon
          icon={faArrowRightFromBracket}
          flip="horizontal"
          style={{ color: "#5f6368" }}
        />
      ),
      click: () => {
        handleCloseUserMenu();
        clearLocalStorageExcept();
        sessionStorage.clear();
        signOut();
      },
    },
  ];

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const clearSearchFunction = () => {
    setSearch("");
  };

  const { currentRole } = useData();
  const isAdminRoute = pathName?.includes("/admin/");

  return (
    // Project developer / reviewer code
    <StyleDrawer
      variant="permanent"
      className="level-1"
      sx={{
        display: "none",
        "@media (min-width: 900px)": {
          display: "block",
        },
        margin: "0",
        boxSizing: "border-box",
        position: "sticky !important",
        top: "0px",
        width: "100%",
        height: "100%",
        // zIndex: 1000
      }}
      open={open}
    >
      <VeBox
        sx={{
          width: { sm: "100%" },
          overflow: "visible",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {/* <VeBox sx={{ width: { sm: "100%", xl: "90%" } }}> */}
        <DrawerHeader
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "56px !important",
            padding: "16px 20px 12px 20px",
            // backgroundColor: "white",
            // overflow: "hidden",
            backgroundColor: isAdminRoute ? "#F5F4FA" : "transparent",
          }}
          className="level-2"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <VeBox
            display={"flex"}
            alignItems="center"
            // sx={{ overflow: "hidden", backgroundColor: "white" }}
            zIndex={10000}
            className="level-3"
          >
            {open ? (
              <VeSearch
                name="search"
                style={{ width: "200px" }}
                placeHolder="Search menu"
                search
                value={search}
                onChange={handleSearch}
                clearSearch={search?.length > 0}
                clearSearchFunction={clearSearchFunction}
              />
            ) : (
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                cursor={"pointer"}
                style={{ color: "#5f6368", width: "16px" }}
                onClick={handleDrawerOpen}
              />
            )}
          </VeBox>
          <VeBox
            sx={{
              border: "0.5px solid #D5DBE1",
              width: "20px",
              height: "20px",
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              position: "absolute",
              right: "-12px",
              "&:hover": {
                border: "0.5px solid #703DDE",
              },
              backgroundColor: "#ffffff",
            }}
            onClick={open ? handleDrawerCloseWeb : handleDrawerOpen}
          >
            {!open ? (
              <FontAwesomeIcon
                width={8}
                height={8}
                color="#5F6368"
                icon={faAngleRight}
              />
            ) : (
              <FontAwesomeIcon
                width={8}
                height={8}
                color="#5F6368"
                icon={faAngleLeft}
              />
            )}
          </VeBox>
        </DrawerHeader>
        <DrawerData
          pathName={pathName}
          selectedItem={selectedItem}
          childSelected={childSelected}
          handleItemClick={handleItemClick}
          setChildSelected={setChildSelected}
          open={open}
          search={search}
          setSearch={setSearch}
          handleDrawerOpen={handleDrawerOpen}
          openSubItemsAccordionWhenClosed={openSubItemsAccordionWhenClosed}
          setopenSubItemsAccordionWhenClosed={
            setopenSubItemsAccordionWhenClosed
          }
          handleClearOpenedSubItemsAccordion={
            handleClearOpenedSubItemsAccordion
          }
        />
      </VeBox>
    </StyleDrawer>
  );
};

export default WebDrawerUser;
